{
  "loading": "Φόρτωση...",
  "placeholder": "Επιλέξτε…"
}